import {
  images,
  scrolling,
} from 'assets/utilities';

import {
  faq,
  kitTestimonials,
} from 'assets/components';

import './kit.scss';

const destroy = function destroyKit() {
  kitTestimonials.destroy();
  faq.destroy();
};

const init = function initKit() {
  window.scrollTo(0, 0);
  scrolling.rebuildCache();
  images.init();
  kitTestimonials.init();
  faq.init();
};

export default {
  destroy,
  init,
};
